var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.5C6.87211 2.5 2.5 6.87211 2.5 12.25C2.5 17.6279 6.87211 22 12.25 22C17.6279 22 22 17.6279 22 12.25C22 6.87211 17.6279 2.5 12.25 2.5ZM16.3553 13.7895H13.7895V16.3553C13.7895 17.1968 13.0916 17.8947 12.25 17.8947C11.4084 17.8947 10.7105 17.1968 10.7105 16.3553V13.7895H8.14474C7.30316 13.7895 6.60526 13.0916 6.60526 12.25C6.60526 11.4084 7.30316 10.7105 8.14474 10.7105H10.7105V8.14474C10.7105 7.30316 11.4084 6.60526 12.25 6.60526C13.0916 6.60526 13.7895 7.30316 13.7895 8.14474V10.7105H16.3553C17.1968 10.7105 17.8947 11.4084 17.8947 12.25C17.8947 13.0916 17.1968 13.7895 16.3553 13.7895Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleIcon);
export default __webpack_public_path__ + "static/media/add-circle-icon.f180c34654f79409e5077cc3495eaef6.svg";
export { ForwardRef as ReactComponent };